import { jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material';
import { Button } from '../Button/Button.js';
import 'react';
import '../Listbox/ListBox.js';

function QuickFiltersButton({ id, onClick, "data-testid": dataTestIdProp, "aria-selected": ariaSelected, children, }) {
    const dataTestId = `${dataTestIdProp !== null && dataTestIdProp !== void 0 ? dataTestIdProp : id}-quick-filter-item`;
    const color = ariaSelected ? "primary" : "ghost-blue";
    return (jsx(StyledButton, { "aria-selected": ariaSelected, color: color, "data-testid": dataTestId, sxText: { padding: 0 }, onClick: onClick, children: children }));
}
const StyledButton = styled(Button)(({ theme, "aria-selected": ariaSelected }) => (Object.assign(Object.assign(Object.assign({ minHeight: 24 }, theme.typography.tinyBold), { "&:active": {
        outline: "none",
    } }), (ariaSelected && {
    "&:focus": {
        outline: "none",
    },
}))));

export { QuickFiltersButton };
//# sourceMappingURL=QuickFiltersButton.js.map
